import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const i18nPrefix = "ConsentWall";

const ConsentWall = ({ onAccept }) => {
  const { t } = useTranslation();
  const [permanentConsent, setPermanentConsent] = useState(true);

  useEffect(() => {
    const storedConsent = localStorage.getItem("googleMapsCookiesAccepted");
    if (storedConsent === "true") {
      onAccept(true);
    }
  }, [onAccept]);

  const handleAccept = () => {
    if (permanentConsent) {
      localStorage.setItem("googleMapsCookiesAccepted", "true");
    }
    onAccept(permanentConsent);
  };

  return (
    <div className="consent-card">
      <div className="consent-title">{t(`${i18nPrefix}.cardTitle`)}</div>
      <div className="consent-text">{t(`${i18nPrefix}.cardText`)}</div>
      <div className="consent-checkbox">
        <input
          id="permanentConsentCheckbox"
          type="checkbox"
          checked={permanentConsent}
          onChange={(e) => setPermanentConsent(e.target.checked)}
        />
        <label htmlFor="permanentConsentCheckbox">
          {t(`${i18nPrefix}.permanentConsentLabel`)}
        </label>
      </div>
      <button className="consent-button" onClick={handleAccept}>
        {t(`${i18nPrefix}.acceptButton`)}
      </button>
    </div>
  );
};

export default ConsentWall;
